import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-doctors-station-oem-header',
  templateUrl: './doctors-station-oem-header.component.html',
  styleUrls: ['./doctors-station-oem-header.component.css'],
})
export class DoctorsStationOemHeaderComponent implements OnChanges {
  imgpath: string;

  @Input()
  clientId: string;

  ngOnChanges(changes: SimpleChanges): void {
    this.imgpath = environment.apps[this.clientId].oemConfig?.imgpath;
  }
}
